import { render, staticRenderFns } from "./SupplierApprovedQuotes.vue?vue&type=template&id=aee998c8&scoped=true&"
import script from "./SupplierApprovedQuotes.vue?vue&type=script&lang=js&"
export * from "./SupplierApprovedQuotes.vue?vue&type=script&lang=js&"
import style0 from "./SupplierApprovedQuotes.vue?vue&type=style&index=0&id=aee998c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee998c8",
  null
  
)

export default component.exports